import { ls, t } from '../i18n';
import { HOOK_STYLE_CHOICES, HOOK_STYLE_LABELS, type HookAccent, type HookDesign } from '@reels/shared/constants';
import { HookOverlay } from './HookOverlay';
import './HookStylePicker.css';

export function HookStylePicker({ value, onChange, text, accent, accentMode, fontFamily, box }: {
  value: HookDesign; onChange: (style: HookDesign) => void; text?: string; accent?: string;
  accentMode?: HookAccent; fontFamily?: string; box?: boolean | 'white' | 'black';
}) {
  return <div className="hook-styles" role="group" aria-label={t('editor.hook.style')}>
    {HOOK_STYLE_CHOICES.map(design => <button key={design} type="button" className="hook-style-option"
      aria-pressed={value === design} onClick={() => onChange(design)} aria-label={ls(HOOK_STYLE_LABELS[design])}>
      <span className="hook-style-sample" aria-hidden="true">
        <HookOverlay text={text?.trim() || t('editor.hookSample')} position="bottom" subtitlesEnabled={false} design={design} accent={accent} accentMode={accentMode} fontFamily={fontFamily} box={box} thumbnail />
      </span>
      <span className="hook-style-name">{ls(HOOK_STYLE_LABELS[design])}<span aria-hidden="true">{value === design ? '✓' : ''}</span></span>
    </button>)}
  </div>;
}
